import { memo } from "react";

import { Badge, Card, Group, Stack, Text } from "@mantine/core";
import { TbFlask2 } from "react-icons/tb";

import OutcomeChip from "modules/experiments/components/OutcomeChip";

import { formatDate } from "modules/core/utils/helpers";
import { experimentsPrivateRoutesConstants } from "modules/experiments/routes/private/routesConstants";

export type DisplayExperimentProps = {
  id: string;
  project_id: string;
  name: string;
  hypothesis: string;
  status: string;
  startDate?: string;
  endDate?: string;
  outcome?: string;
};

const DisplayExperiment = (props: DisplayExperimentProps) => {
  const {
    id,
    project_id,
    name,
    hypothesis,
    status,
    startDate,
    endDate,
    outcome
  } = props;

  return (
    <Card
      withBorder
      component="a"
      href={experimentsPrivateRoutesConstants.single_experiment.href(
        id,
        project_id
      )}
      target="_blank"
      rel="noopener noreferrer"
      shadow="xs"
      radius="lg"
    >
      <Stack gap="xs">
        <Badge
          size="xs"
          color="indigo"
          variant="transparent"
          tt="capitalize"
          leftSection={<TbFlask2 size={12} />}
        >
          Experiment
        </Badge>

        <div>
          <Text size="sm" fw={600}>
            {name}
          </Text>

          {hypothesis ? (
            <Text size="xs" c="gray.6">
              {hypothesis}
            </Text>
          ) : null}
        </div>

        <Group justify="space-between">
          <Group gap="xs">
            <Badge size="xs" variant="light" tt="capitalize">
              {status}
            </Badge>

            {outcome ? <OutcomeChip outcome={outcome.toLowerCase()} /> : null}
          </Group>

          <Text size="xs" c="gray.6">
            {`${formatDate({ datestring: startDate, dateFormat: "dd MMM yyyy" })} - ${formatDate({ datestring: endDate, dateFormat: "dd MMM yyyy" })}`}
          </Text>
        </Group>
      </Stack>
    </Card>
  );
};

export default memo(DisplayExperiment);
